@if(showMenu){
<section class="card">
  <div class="card-content">
    <p class="card-title">{{ title }}</p>
    <sl-typography
      [text]="subtitle"
      variant="body-20"
      color="var(--color-neutral-90)"
    ></sl-typography>
    @for(item of menuItems; track item){
    <div class="card-tab">
      <div class="item-container">
        <div class="label-container">
          <sl-typography [text]="item.label" variant="body-10" weight="medium"></sl-typography>
        </div>
        @if(item.tag){
        <sl-tag
          [label]="item.tag"
          [color]="tagColorVariants.PURPLE"
          [size]="tagSize.SMALL"
        ></sl-tag>
        }
      </div>
      @for(tag of item.content; track tag; let i = $index){
      <div class="menu-items-container" (focusout)="onFocusoutItems($event)">
        <sl-menu-item
          [item]="{
            key: tag.label,
            value: tag.url
          }"
          [icon]="tag.icon"
          (clickEvent)="onClickTag($event)"
          (keyDownEvent)="onKeyDownTag($event)"
        ></sl-menu-item>
      </div>
      }
    </div>
    }
    <sl-button
      [id]="'sl-menu-item-logout-button'"
      type="label"
      variant="tertiary"
      label="Log Out"
      (clickEvent)="onClickLogOut()"
      (keydown)="onKeyDownLogOut($event)"
      (focusout)="onFocusoutItems($event)"
    ></sl-button>
  </div>
</section>
}
